module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/photo7-6-b13919ca610b15da6d0909b6d285650c.png";